<template>
    <SwitchGroup>
        <div class="flex items-center">
            <SwitchLabel
                v-if="leftLabel !== ''"
                passive
                class="mr-3 cursor-pointer"
                :class="{
                    'text-gray-800': !enabled,
                    'text-gray-400': enabled,
                }"
                @click="enabled = false"
                >{{ leftLabel }}</SwitchLabel
            >
            <Switch
                v-model="enabled"
                :class="enabled ? 'bg-[#FF421E]' : 'bg-gray-300'"
                class="relative inline-flex h-6 w-11 items-center rounded-full"
            >
                <span class="sr-only">Enable notifications</span>
                <span
                    :class="enabled ? 'translate-x-6' : 'translate-x-1'"
                    class="inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ease-in-out"
                />
            </Switch>
            <SwitchLabel
                v-if="rightLabel !== ''"
                passive
                :class="{
                    'text-gray-800': enabled,
                    'text-gray-400': !enabled,
                }"
                class="ml-3 cursor-pointer"
                @click="enabled = true"
                >{{ rightLabel }}</SwitchLabel
            >
        </div>
    </SwitchGroup>
</template>

<script lang="ts" setup>
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    leftLabel: {
        type: String,
        default: "",
    },
    rightLabel: {
        type: String,
        default: "",
    },
});

const emit = defineEmits(["update:modelValue"]);

const enabled = computed({
    get() {
        return props.modelValue;
    },
    set(val: boolean) {
        emit("update:modelValue", val);
    },
});
</script>
